import React, { useEffect } from 'react';
import './AboutUs.css';
import {  Link, useNavigate } from 'react-router-dom';




const AboutUs = () => {
    // Scroll to top when component mounts

const navigate = useNavigate();


    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, []);

    return (
        <div className="about-us-container">
            <div className="about-us-hero">
                <div className="about-us-overlay">
                    <h1>Our Story</h1>
                    <p>Passion, Innovation, and a Vision for Change</p>
                </div>
            </div>

            <div className="about-us-content">
                <div className="about-us-section company-info">
                    <h2>About Procart India</h2>
                    <p>A unit of NexSpyder Technologies Pvt. Ltd.</p>
                    <div className="company-mission">
                        <p>
                            Procart India was born out of pure passion, real frustration, and an unshakable
                            drive to make things better for makers like you.
                        </p>
                    </div>
                </div>

                <div className="about-us-section founder-journey">
                    <div className="journey-content">
                        <h2>The Founder's Journey</h2>
                        <div className="journey-timeline">
                            <div className="timeline-item">
                                <div className="timeline-marker childhood"></div>
                                <div className="timeline-content">
                                    <h3>Childhood Curiosity</h3>
                                    <p>
                                        My journey with electronics began in childhood — not in a lab, but in everyday curiosity.
                                        When my parents brought home something new, like a torch, I wasn't interested in using it —
                                        I wanted to open it up and see how it worked.
                                    </p>
                                    <p>
                                        I still remember sneaking ₹4 from my mom's purse just to buy a battery to light up a small bulb.
                                        She caught me — and yes, I got a scolding — but that tiny moment sparked something big inside me.
                                    </p>
                                </div>
                            </div>

                            <div className="timeline-item">
                                <div className="timeline-marker education"></div>
                                <div className="timeline-content">
                                    <h3>Academic Excellence</h3>
                                    <p>
                                        As I grew older, this curiosity turned into a passion. I participated in school science exhibitions,
                                        won prizes at technical summits and hackathons, and kept pushing my skills forward.
                                    </p>
                                    <p>
                                        In engineering college, I went beyond textbooks — building complex and creative projects like
                                        autonomous robots, submarines, and image-processing systems. I even started helping seniors with
                                        their final-year projects, eventually designing complete systems from scratch — both technically
                                        and mechanically.
                                    </p>
                                </div>
                            </div>

                            <div className="timeline-item">
                                <div className="timeline-marker career"></div>
                                <div className="timeline-content">
                                    <h3>Corporate Disconnect</h3>
                                    <p>
                                        After college, I landed a job at a well-known MNC. But within few months, I knew I didn't
                                        belong there. Sitting in front of a screen, disconnected from real-world innovation,
                                        just wasn't for me.
                                    </p>
                                    <p>
                                        So, I took a leap — and started building robots, electronic systems, and products for real clients.
                                    </p>
                                </div>
                            </div>

                            <div className="timeline-item">
                                <div className="timeline-marker challenges"></div>
                                <div className="timeline-content">
                                    <h3>Facing Industry Challenges</h3>
                                    <p>
                                        That's when the real problem became painfully clear: Getting quality components in India
                                        was slow, unreliable, and frustrating.
                                    </p>
                                    <ul className="challenges-list">
                                        <li>Half the local shops sold fake or damaged boards.</li>
                                        <li>Even for a single urgent component, I had to travel 1–2 hours, wasting half a day.</li>
                                        <li>Online platforms took 5–10 days to deliver, even for basic parts.</li>
                                        <li>And even after the component arrived — there was no guidance on how to use it.</li>
                                        <li>Project timelines stretched for days or weeks — just waiting for parts or answers.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="timeline-item">
                                <div className="timeline-marker solution"></div>
                                <div className="timeline-content">
                                    <h3>Creating the Solution</h3>
                                    <p>
                                        I knew I wasn't alone. Every student, engineer, startup, and hobbyist were going through
                                        the same pain. That's when I decided to solve it — and built Procart India.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="about-us-section our-mission">
                    <h2>Our Mission</h2>
                    <div className="mission-cards">
                        <div className="mission-card">
                            <div
                                className="mission-icon quality"
                                style={{
                                    backgroundImage: "url('https://cdn-icons-png.flaticon.com/512/190/190411.png')",
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    width: "60px",
                                    height: "60px",
                                    margin: "0 auto",
                                }}
                            ></div>
                            <h3>Quality Assurance</h3>
                            <p>We rigorously test all components to ensure you only receive genuine, high-quality products.</p>
                        </div>

                        <div className="mission-card">
                            <div
                                className="mission-icon speed"
                                style={{
                                    backgroundImage: "url('https://cdn-icons-png.flaticon.com/512/609/609361.png')",
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    width: "60px",
                                    height: "60px",
                                    margin: "0 auto",
                                }}
                            ></div>
                            <h3>Rapid Delivery</h3>
                            <p>Get the components you need quickly so your projects don't face unnecessary delays.</p>
                        </div>

                        <div className="mission-card">
                            <div
                                className="mission-icon support"
                                style={{
                                    backgroundImage: "url('https://cdn-icons-png.flaticon.com/512/2950/2950661.png')",
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    width: "60px",
                                    height: "60px",
                                    margin: "0 auto",
                                }}
                            ></div>
                            <h3>Expert Guidance</h3>
                            <p>Beyond just selling components, we provide technical support and advice when you need it.</p>
                        </div>
                    </div>

                </div>

                <div className="about-us-section join-us">
                    <h2>Join Us on This Journey</h2>
                    <p>
                        Procart India is more than just a store—it's a community of makers, innovators, and problem-solvers.
                        Whether you're a student, hobbyist, professional engineer, or startup, we're here to support your creative journey.
                    </p>
                   <Link to="/products" className="shop-now-btn">
                        Explore Our Products
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;